const imageContainerBasic = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2px',
  marginRight: '4px',
  borderRadius: '8px',
  transition: 'background-color 0.3s ease',
} as const;

export const ContentStyle = {
  imageContainerWhite: {
    ...imageContainerBasic,
    backgroundColor: 'white',
  },
  imageContainerHover: {
    ...imageContainerBasic,
    backgroundColor: 'rgba(55, 65, 81, 0.2)',
  },
  image: {
    margin: '0 auto',
    cursor: 'pointer',
    display: 'flex',
  },
} as const;
